/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const fontDataSchema = z.object({
	id: z.string(),
	displayName: z.string(),
	weight: z.string(),
	style: z.string(),
	url: z.string(),
	mimeType: z.string().nullable(),
	createdAt: z.iso.datetime(),
})

export type FontDataSchema = z.infer<typeof fontDataSchema>
